module.exports = __webpack_public_path__ + "img/FengShuiDragon_DG.e869f35b.jpg";